export class ClubSlugNotFoundError extends Error {
  constructor() {
    super("The ClubSlug couldn't be found");
  }
}
